module.exports = __webpack_public_path__ + "img/Apricot.a6b773da.svg";